import styled from "styled-components";
import DisplayInputComponent from "../common/displayInputComponent";
import { Image } from "../common/image";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const NameBox = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 36%;
  height: 100%;
  padding-left: 2vw;
`;

const QuantityBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
  height: 100%;
`;
const CbmBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
  height: 100%;
`;
const MethodBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
  height: 100%;
`;

const DeleteBox = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 15%;
  height: 100%;
  padding-right: 2vw;
`;

export default function ItemComponent(props: any) {
  const { data, deleteItem, roomId } = props;

  const onclickDeleteItem = (itemId: number) => {
    if (!window.confirm("해당 물품을 정말 삭제하시겠습니까?")) {
      return;
    }
    deleteItem(roomId, itemId);
  };

  return (
    <Wrapper>
      <NameBox>
        [{data.category}] {data.item}
      </NameBox>
      <QuantityBox>
        <DisplayInputComponent data={data.quantity}></DisplayInputComponent>
      </QuantityBox>
      <CbmBox>
        <DisplayInputComponent data={data.cbm}></DisplayInputComponent>
      </CbmBox>
      <MethodBox>
        <DisplayInputComponent
          data={data.carryType}
          isMethod
        ></DisplayInputComponent>
      </MethodBox>
      <DeleteBox onClick={() => onclickDeleteItem(data.id)}>
        <Image
          src={`/icon/delete.png`}
          width={"2.4vw"}
          height={"2.4vw"}
        ></Image>
      </DeleteBox>
    </Wrapper>
  );
}
